import { postRequest, getRequest } from "./apiService";
import { API_BASE_URL } from "../config/config";

/**
 * Enables customer NAICS CMI configuration for an application via API.
 *
 * @param {Object} params - Parameters for the request.
 * @param {string} params.applicationId - The application ID.
 * @param {string} params.changeType - The type of change - Must be 'naics' or 'cmi'.
 * @param {string|number} params.value - The value to be applied.
 * @param {boolean} params.enable - Whether to enable the setting.
 * @param {string} params.accessToken - Access token for authentication.
 * @param {string} params.refreshToken - Refresh token for authentication.
 * @returns {Promise<Object>} - The JSON response from the API.
 */
export async function enableCustomerNaicsCMI({
  applicationId,
  changeType,
  value,
  enable,
  accessToken,
  refreshToken,
}) {
  const url =
    `${API_BASE_URL}/insureai/ml/intake/applications/v2/customer_naics_cmi_enable` +
    `?application_id=${applicationId}&change_type=${changeType}&value=${value}&enable=${enable}`;

  const headers = {
    accept: "application/json",
    "X-Access-Token": accessToken,
    "X-Refresh-Token": refreshToken,
  };

  try {
    const response = await postRequest(url, null, headers); // no body required
    return response;
  } catch (error) {
    console.error("Error enabling customer NAICS/CMI:", error);
    throw error;
  }
}

/**
 * Checks the decision progress status for a given application.
 *
 * @param {string} applicationId - The ID of the application to check.
 * @param {string} accessToken - The user's access token for authentication.
 * @param {string} refreshToken - The user's refresh token for authentication.
 * @returns {Promise<Object>} - Response from the API with progress status.
 */
export async function checkDecisionProgress(
  applicationId,
  accessToken,
  refreshToken
) {
  const url = `${API_BASE_URL}/insureai/ml/intake/applications/v2/check_decision_progress?application_id=${applicationId}`;

  const headers = {
    accept: "application/json",
    "X-Access-Token": accessToken,
    "X-Refresh-Token": refreshToken,
  };

  try {
    const response = await getRequest(url, headers);
    return response;
  } catch (error) {
    console.error("Error checking decision progress:", error);
    throw error;
  }
}
